import {v4 as uuid} from 'uuid'

export default class FigmaRequestor {
  private pendingRequests: any = {}

  public constructor() {
    window.addEventListener('message', (event) => {
      if (event.data && event.data.figmaServiceResponseId) {
        this.handleEvent(event)
      }
    })
  }

  private handleEvent = (event: any) => {
    if (this.pendingRequests[event.data.figmaServiceResponseId]) {
      if (event.data.error) {
        this.pendingRequests[event.data.figmaServiceResponseId].reject(event.data.error)
      } else {
        this.pendingRequests[event.data.figmaServiceResponseId].fulfill(event.data.payload)
      }
    }
  }

  public exec = <V = any>(type: string, data?: any) => {
    const id = uuid()

    return new Promise<V>((fulfill, reject) => {
      this.pendingRequests[id] = {
        fulfill: (payload: any) => {
          fulfill(payload)
          delete this.pendingRequests[id]
        },
        reject: (error: any) => {
          reject(error)
          delete this.pendingRequests[id]
        },
      }

      window.parent.postMessage(
        {
          figmaServiceEvent: type,
          figmaServiceEventId: id,
          payload: data,
        },
        '*'
      )
    })
  }
}
